import React, { Component } from 'react'
import './styles.css'
import { Formik, Field, Form } from 'formik'
import { apiEmployee } from '../../services/apiamrg'
import Header from '../../components/header'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import { NOME_EMPRESA, PRECISA_LOGAR } from '../../config'
import moment from 'moment'
import Util from '../../classes/util'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Formlabel from '@material-ui/core/FormLabel'
import Select from 'react-select'
import makeAnimated from 'react-select/animated';
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import DatePicker from 'react-date-picker';
import { Dots, Squares } from "react-activity";
import { Input } from '@material-ui/core'
const estadoInicial = {
    Nome: '',
    CPF: '',
    senha: '',
    confirmar_senha: '',
    email: '',
    loading: false,
    baseprodutos: [],
    redirect: false,
    produtoscardapio: [],
    empresas: [],
    empresaselecionada: [],
    bloqueado: [
        {
            value: 0,
            label: 'Não'
        },
        {
            value: 1,
            label: 'Sim'
        }
    ],
    bloqueados_selecionados: {
        value: 0,
        label: 'Não'
    },
    dias_da_semana: [{ label: 'Domingo', value: 1 }, { label: 'Segunda-Feira', value: 2 }, { label: 'Terça-Feira', value: 3 }, { label: 'Quarta-Feira', value: 4 }, { label: 'Quinta-Feira', value: 5 }, { label: 'Sexta-Feira', value: 6 }, { label: 'Sabado', value: 7 }],
    tiposelecionado: [],
    data_inicial: new Date(),
    data_final: new Date(),
    produtosselecionados: [],
    diaSelecionado: []


}

class AddClient extends Component {

    state = {
        ...estadoInicial
    }



    componentDidMount = async () => {
        this.empresas()

        if (this.props.location.state.usuario) {
            const user = this.props.location.state.usuario
            // console.log(user)
            if (user.bloqueado != "") {
                this.setState({
                    bloqueados_selecionados: {
                        value: 1,
                        label: 'Sim'
                    }
                })

            }
            this.setState({ Nome: user.nome, CPF: user.cpf, empresaselecionada: user.chave_empresa, email: user.email })
        }

    }

    alteruser = async () => {

        let certo = moment().format('YYYY-MM-DD');

        if (this.state.bloqueados_selecionados.value == 0) {
            certo = ''
        }

        apiEmployee.post('atualizarusuario', {
            Nome: this.state.Nome,
            chave: this.props.location.state.usuario.chave,
            cpf: this.state.CPF,
            email: this.state.email,
            bloqueado: certo,
            senha: this.state.senha,
            chave_empresa: this.state.empresaselecionada.value,
        }).then(res => {

            this.setState({ redirect: true })

        }).catch(err => console.error(err))





    }

    salvarusuario = async () => {
        let certo = moment().format('YYYY-MM-DD');

        if (this.state.bloqueados_selecionados.value == 0) {
            certo = ''
        }

        apiEmployee.post('cadastrarusuario', {
            Nome: this.state.Nome,
            cpf: this.state.CPF,
            email: this.state.email,
            bloqueado: certo,
            senha: this.state.senha,
            chave_empresa: this.state.empresaselecionada.value,
        }).then(res => {

            this.setState({ redirect: true })

        }).catch(err => alert(err))
    }

    colocar_nome = (a, b) => {

        if (!a.search(/^[a-zA-Z\s]*$/)) {
            this.setState({ Nome: a })
            if (a.length > 2) {

                b.currentTarget.parentElement.parentElement.lastChild.style.display = 'none'
            } else {
                b.currentTarget.parentElement.parentElement.lastChild.style.display = 'block'
            }

        } else {
            b.currentTarget.parentElement.parentElement.lastChild.style.display = 'block'
        }
    }

    colocar_cpf = (a, b) => {

        if (!a.search(/^[0-9]+$/) || a == '') {

            this.setState({ CPF: a })
            if (a.length == 11) {

                b.currentTarget.parentElement.parentElement.lastChild.style.display = 'none'
            } else {
                b.currentTarget.parentElement.parentElement.lastChild.style.display = 'block'
            }
        } else {
            b.currentTarget.parentElement.parentElement.lastChild.style.display = 'block'
        }
    }


    colocar_senha = (a, b) => {
        this.setState({ senha: a })
        if (a.length >= 6) {
            b.currentTarget.parentElement.parentElement.lastChild.style.display = 'none'
        } else {
            b.currentTarget.parentElement.parentElement.lastChild.style.display = 'block'
        }
    }



    empresas = async () => {
        apiEmployee.get('pegartodasempresas').then(res => {

            let vetor = []
            let vetor2 = []
            res.data.map(element => {
                let option = {
                    label: element.Nome, value: element.Chave
                }
                vetor.push(option)
                if (this.props.location.state.usuario.chave_empresa == element.Chave) {
                    // console.log('entro aqui')
                    let option2 = {
                        label: element.Nome, value: element.Chave
                    }
                    vetor2 = option2
                }
            })
            this.setState({ empresas: vetor, empresaselecionada: vetor2 })
        })
    }

    empresascerta = async (chave) => {
        apiEmployee.get('pegartodasempresas').then(res => {

            let vetor = []
            let vetor2 = []
            res.data.map(element => {
                let option = {
                    label: element.Nome, value: element.Chave
                }
                vetor.push(option)
                if (this.props.location.state.user.chave_empresa == element.Chave) {
                    // console.log('entro aqui')
                    let option2 = {
                        label: element.Nome, value: element.Chave
                    }
                    vetor2 = option2
                }
            })
            this.setState({ empresas: vetor, empresaselecionada: vetor2 })
        })
    }





    render() {
        const validations = []
        validations.push(this.state.ship_name && this.state.ship_name.trim().length >= 3)


        //o formulário só será válido se todas as validações forem verdadeiras, com este reduce implementado
        const validForm = validations.reduce((t, a) => t && a)

        return (
            <div>
                {this.state.redirect &&
                    <Redirect to={'/admin/clients'} />
                }
                <Header voltarCliente />

                <div className='titulo100'><span> {this.props.location.state.usuario ? 'Deletar Usuario' : 'Criar Usuário'} </span></div>

                <div className='centrom'>

                    <div className='col-9 row containeralterarcardapio'>
                        <div className='col-6 contcard'>
                            <span> Nome Completo</span>
                            <Input value={this.state.Nome} onChange={(a) => this.colocar_nome(a.currentTarget.value, a)} />
                            <span>Nome Inválido</span>
                        </div>
                        <div className='col-6 contcard'>
                            <span> CPF</span>
                            <Input value={this.state.CPF} onChange={(a) => this.colocar_cpf(a.currentTarget.value, a)} />
                            <span>CPF já utilizado ou inválido</span>
                        </div>

                        <div className='col-6 contcard'>
                            <span> Senha</span>
                            <Input type='password' value={this.state.senha} onChange={(a) => this.colocar_senha(a.currentTarget.value, a)} />
                            <span>Senha tem que ter no minimo 6 caracteres </span>
                        </div>

                        <div className='col-6 contcard'>
                            <span>Confirmar Senha</span>
                            <Input type='password' value={this.state.confirmar_senha} onChange={(a) => this.setState({ confirmar_senha: a.currentTarget.value })} />
                            <span>Senhas não conferem</span>
                        </div>


                        <div className='col-6 contcard'>
                            <span> Bloqueado</span>

                            <Select value={this.state.bloqueados_selecionados} options={this.state.bloqueado} onChange={a => { this.setState({ bloqueados_selecionados: a });  }} />
                            <span>Não Selecionado</span>
                        </div>

                        <div className='col-6 contcard'>
                            <span> Empresa</span>
                            <Select value={this.state.empresaselecionada} options={this.state.empresas} onChange={a => this.setState({ empresaselecionada: a })} />
                            <span>Não Selecionado</span>
                        </div>

                        <div className='col-12 contcard'>
                            <span> Email</span>

                            <Input value={this.state.email} onChange={(a) => this.setState({ email: a.currentTarget.value })} />
                            <span>Email em uso ou inválido</span>
                        </div>

                        <div className='col-12 contvtt'>
                            <button type='button' onClick={() => {this.props.location.state.usuario ?  this.alteruser()  : this.salvarusuario()}}> {this.props.location.state.usuario ? 'Alterar Usuario' : 'Criar Usuario'}</button>

                            {this.state.loading && <Squares color={'black'} size={40} speed={0.5} />}
                        </div>

                    </div>

                </div>



            </div>
        )

        /*
    
        className={'form-check-input ' + (errors.acceptTerms && touched.acceptTerms ? ' is-invalid' : '')}
        
           return (
            <section className="latest-products spad">
                <div className="container">
                    <div className="product-filter">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                                <div className="section-title">
                                    <h2>Administrador</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="contender">
                        <p>Login</p>
                        <p>Senha</p>
                    </div>                
                </div>
        </section> 
        )
        */
    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        token: user.token,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(AddClient)


/*
carregaPortos = async () => {
    if(this.props.online){
        await api.get(`seaports`, {
            headers: {
                "Authorization": `bearer ${this.props.token}`
            }
        })
        .then(
            response => {this.setState({seaports: response.data})},
            response => this.erroApi(response)
        )
    }else{
        await apiLocal.get(`seaports`, {
            headers: {
                "Authorization": `bearer ${this.props.token}`
            }
        })
        .then(
            response => {this.setState({seaports: response.data})},
            response => this.erroApi(response)
        )
    } 
}

loadData = async (produto) => {
    try{
        if(this.props.online){
            await api.get(`ships/${produto}`, {
                headers: {
                    "Authorization": `bearer ${this.props.token}`
                }
            }).then(async res => {
                await this.setState({seaport_origin: res.data.seaport_orig, seaport_destiny: res.data.seaport_dest, ship_name: res.data.name, id_seaport: res.data.id_seaport, terminal: res.data.terminal, eta: Util.formataData(res.data.ETA), etb: Util.formataData(res.data.ETB), ets: Util.formataData(res.data.ETS), type: res.data.type, dosage: res.data.dosage, full_shipment: res.data.full_shipment, shipment: res.data.shipment, cargo: res.data.cargo, doomed: res.data.doomed, recirculation: res.data.recirculation, status: res.data.status})
            })
        }else{
            await apiLocal.get(`ships/${produto}`, {
                headers: {
                    "Authorization": `bearer ${this.props.token}`
                }
            }).then(async res => {
                await this.setState({seaport_origin: res.data.seaport_orig, seaport_destiny: res.data.seaport_dest, ship_name: res.data.name, id_seaport: res.data.id_seaport, terminal: res.data.terminal, eta: Util.formataData(res.data.ETA), etb: Util.formataData(res.data.ETB), ets: Util.formataData(res.data.ETS), type: res.data.type, dosage: res.data.dosage, full_shipment: res.data.full_shipment, shipment: res.data.shipment, cargo: res.data.cargo, doomed: res.data.doomed, recirculation: res.data.recirculation, status: res.data.status})
            })
        }

    }catch(e){
        alert(e)
    }
}

/*
inserirNavio = async () => {
    if(this.state.id == 0){
        if(this.props.online){
            await api.post(`ships`, {
                ship_name: this.state.ship_name,
                seaport_origin: this.state.seaport_origin,
                id_seaport: this.state.id_seaport,
                seaport_destiny: this.state.seaport_destiny,
                terminal: this.state.terminal,
                agent: this.state.agent,
                eta: this.state.eta,
                etb: this.state.etb,
                ets: this.state.ets,
                type: this.state.type,
                dosage: this.state.dosage,
                full_shipment: this.state.full_shipment,
                shipment: this.state.shipment,
                cargo: this.state.cargo,
                doomed: this.state.doomed,
                recirculation: this.state.recirculation,
                status: this.state.status
            }, {
                headers: {
                "Authorization": `bearer ${this.props.token}`
                }
            }).then(response => {
                if(response.status === 204){
                    alert("Cadastro realizado corretamente!")
                }else{
                    alert("Erro no cadastro! Tente novamente!")
                }
            })
        }else{
            await apiLocal.post(`ships`, {
                ship_name: this.state.ship_name,
                seaport_origin: this.state.seaport_origin,
                id_seaport: this.state.id_seaport,
                seaport_destiny: this.state.seaport_destiny,
                terminal: this.state.terminal,
                agent: this.state.agent,
                eta: this.state.eta,
                etb: this.state.etb,
                ets: this.state.ets,
                type: this.state.type,
                dosage: this.state.dosage,
                full_shipment: this.state.full_shipment,
                shipment: this.state.shipment,
                cargo: this.state.cargo,
                doomed: this.state.doomed,
                recirculation: this.state.recirculation,
                status: this.state.status
            }, {
                headers: {
                "Authorization": `bearer ${this.props.token}`
                }
            }).then(response => {
                if(response.status === 204){
                    alert("Cadastro realizado corretamente!")
                }else{
                    alert("Erro no cadastro! Tente novamente!")
                }
            })
        }
    }else{
        if(this.props.online){
            await api.put(`ships/${this.state.id}`, {
                ship_name: this.state.ship_name,
                seaport_origin: this.state.seaport_origin,
                id_seaport: this.state.id_seaport,
                seaport_destiny: this.state.seaport_destiny,
                terminal: this.state.terminal,
                agent: this.state.agent,
                eta: this.state.eta,
                etb: this.state.etb,
                ets: this.state.ets,
                type: this.state.type,
                dosage: this.state.dosage,
                full_shipment: this.state.full_shipment,
                shipment: this.state.shipment,
                cargo: this.state.cargo,
                doomed: this.state.doomed,
                recirculation: this.state.recirculation,
                status: this.state.status
            }, {
                headers: {
                    "Authorization": `bearer ${this.props.token}`
                }
            }).then(response => {
                if(response.status === 204){
                    alert('Cadastro atualizado!')
                }else{
                    alert("Erro na atualização! Tente novamente!")
                }
            })
        }else{
            await apiLocal.put(`ships/${this.state.id}`, {
                ship_name: this.state.ship_name,
                seaport_origin: this.state.seaport_origin,
                id_seaport: this.state.id_seaport,
                seaport_destiny: this.state.seaport_destiny,
                terminal: this.state.terminal,
                agent: this.state.agent,
                eta: this.state.eta,
                etb: this.state.etb,
                ets: this.state.ets,
                type: this.state.type,
                dosage: this.state.dosage,
                full_shipment: this.state.full_shipment,
                shipment: this.state.shipment,
                cargo: this.state.cargo,
                doomed: this.state.doomed,
                recirculation: this.state.recirculation,
                status: this.state.status
            }, {
                headers: {
                    "Authorization": `bearer ${this.props.token}`
                }
            }
            ).then(response => {
                if(response.status === 204){
                    alert('Cadastro atualizado!')
                }else{
                    alert("Erro na atualização! Tente novamente!")
                }
            })
        }
    }
}
*/